import { render, staticRenderFns } from "./ProformaOptionsDialog.vue?vue&type=template&id=2c340a85"
import script from "./ProformaOptionsDialog.vue?vue&type=script&lang=js"
export * from "./ProformaOptionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports